export default __webpack_public_path__ + "static/media/other-types.b63f859b.svg";